import { useCallback, useEffect, useState } from 'react';
import { ApiKeyService } from '../services/ApiKeyService';
import type { ApiKeyRow } from '../types/apiKey.types';

export function useApiKeysList() {
    const [rows, setRows] = useState<ApiKeyRow[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const load = useCallback(async () => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await ApiKeyService.listar();

            if (response.status !== 'success') {
                throw new Error(response.message || 'No se pudo cargar el listado.');
            }

            setRows(response.data ?? []);
        } catch (err) {
            setRows([]);
            setError(err instanceof Error ? err.message : 'No se pudo cargar el listado.');
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        void load();
    }, [load]);

    return {
        rows,
        isLoading,
        error,
        reload: load,
    };
}
